import { render, staticRenderFns } from "./age.vue?vue&type=template&id=213ba48c&scoped=true&"
import script from "./age.vue?vue&type=script&lang=js&"
export * from "./age.vue?vue&type=script&lang=js&"
import style0 from "./age.vue?vue&type=style&index=0&id=213ba48c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ba48c",
  null
  
)

export default component.exports